import { isResponseErrorTransient } from '../utils/is-response-error-transient';
/**
 * Error that is raised when an HTTP request fails.
 */
export class HttpResponseError extends Error {
    constructor(response) {
        const message = response.statusText
            ? `HTTP ${response.status} ${response.statusText}`
            : `HTTP ${response.status}`;
        super(message);
        this.name = this.constructor.name;
        this.statusCode = response.status;
        this.statusText = response.statusText;
        this.isTransient = isResponseErrorTransient(response);
        this.body = async () => {
            const body = await response.text();
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return JSON.parse(body);
            }
            return body;
        };
    }
}
//# sourceMappingURL=http-response-error.js.map